import { RyuseiCode } from '../../core/RyuseiCode/RyuseiCode';
import { Dialog, Indentation, History, Shortcut } from '../../extensions';


RyuseiCode.compose( { Dialog, Indentation, History, Shortcut } );

export { RyuseiCode as default } from '../../core/RyuseiCode/RyuseiCode';

